var DepartureAirportMapper = /** @class */ (function () {
    function DepartureAirportMapper() {
    }
    DepartureAirportMapper.filter = function (formData) {
        var availableDepartureAirportGroupIds = [1000, 1005, 1006, 1007, 1008, 1011];
        var departureAirportGroups = formData.departureAirportGroups;
        var filteredDepartureAirportGroups = departureAirportGroups.filter(function (airport) { return availableDepartureAirportGroupIds.indexOf(airport.id) !== -1; });
        formData.departureAirportGroups = filteredDepartureAirportGroups;
        return formData;
    };
    return DepartureAirportMapper;
}());
export default DepartureAirportMapper;
